<template>
  <div>
    <!-- Overbought -->
    <helpers-section-sub-header class="mt-8 mb-2">
      Choose stocks trading below the high for a given timeframe.
    </helpers-section-sub-header>
    <p>
      For example, only choose stocks trading within 5% above their 2-year high, or choose stocks
      trading at least 60% below their 3-year high
    </p>

    <v-data-table :headers="ta_headers" :items="criteria.high_low_rules" class="mt-6 mb-8">
      <template #top>
        <v-dialog v-model="taDialog" scrollable max-width="450px">
          <template #activator="{ props }">
            <v-btn color="primary" dark class="mb-4" v-bind="props"> New Rule </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ taTitle }}</span>
            </v-card-title>

            <v-card-text style="height: 350px">
              <p>
                Only consider stocks whose price is
                <span v-if="editedTa.type == 'within'">
                  {{ editedTa.type }}
                </span>
                <span v-else>down more than </span>

                {{ editedTa.min }}% of the {{ editedTa.days }} day high
              </p>
              <v-container>
                <v-row density="compact">
                  <v-col cols="12" sm="12">
                    <v-checkbox v-model="editedTa.enabled" density="compact" label="Rule Enabled" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="editedTa.long_short"
                      :items="long_short"
                      label="Signal Type"
                      hint="Long or Short Signal"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="editedTa.type"
                      :items="['within', 'down']"
                      label="Within or Down"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="editedTa.min"
                      density="compact"
                      hide-details
                      variant="outlined"
                      label="Percent Range"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="editedTa.days"
                      :items="[5, 10, 15, 20, 50, 90, 125, 250, 500, 750, 1000]"
                      label="# of Trading Days"
                      hint=""
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1" />
              <v-btn color="blue-darken-1" text @click="closeTa"> Cancel </v-btn>
              <v-btn color="blue-darken-1" text @click="saveTa"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editTa(item)"> edit </v-icon>
        <v-icon small @click="deleteTa(item)"> delete </v-icon>
      </template>

      <template #item.enabled="{ item }">
        <v-switch v-model="item.enabled" color="primary" />
      </template>
      <template #no-data> No rules configured </template>
    </v-data-table>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  data() {
    return {
      taDialog: false,
      long_short: ['long', 'short'],
      ta_headers: [
        {
          title: 'Enabled',
          align: 'left',
          sortable: true,
          key: 'enabled'
        },
        {
          title: 'Rule Type',
          align: 'left',
          sortable: true,
          key: 'long_short'
        },
        {
          title: 'Type',
          align: 'left',
          sortable: true,
          key: 'type'
        },
        {
          title: 'Trading Days',
          align: 'left',
          sortable: true,
          key: 'days'
        },
        {
          title: '%',
          align: 'left',
          sortable: true,
          key: 'min'
        },

        { title: 'Actions', key: 'action', sortable: false }
      ],
      editedTa: { enabled: true, type: 'down', days: 250, min: 3, long_short: 'long' },
      defaultTa: { enabled: true, type: 'down', days: 250, min: 3, long_short: 'long' },
      editedIndex: -1
    }
  },

  computed: {
    taTitle() {
      return this.editedIndex === -1 ? 'New Rule' : 'Edit Rule'
    },
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {
    taDialog(val) {
      val || this.closeTa()
    }
  },

  created() {},

  methods: {
    editTa(item) {
      this.editedIndex = this.criteria.high_low_rules.indexOf(item)
      this.editedTa = Object.assign({}, item)
      this.taDialog = true
    },

    deleteTa(item) {
      const index = this.criteria.high_low_rules.indexOf(item)
      confirm('Are you sure you want to delete this rule?') &&
        this.criteria.high_low_rules.splice(index, 1)
    },

    closeTa() {
      this.taDialog = false
      setTimeout(() => {
        this.editedTa = Object.assign({}, this.defaultTa)
        this.editedIndex = -1
      }, 300)
    },

    saveTa() {
      if (this.editedIndex > -1) {
        Object.assign(this.criteria.high_low_rules[this.editedIndex], this.editedTa)
      } else {
        if (!this.criteria.high_low_rules) {
          this.criteria.high_low_rules = []
        }
        this.criteria.high_low_rules.push(this.editedTa)
      }
      this.closeTa()
    }
  }
}
</script>
